import React, {useEffect, useState} from 'react';
import { useParams } from 'react-router-dom';
import Loader from '../../../loader';
import CustomAlert from '../../../customAlert';
import VPadminVerkstedLayout from '../../../vpAdminVerkstedLayout';
import { axiosAuthFetch } from '../../../../helpers/apiActions/authFetch';
import { API_BASE_URL } from '../../../../constants';



export function VPspesVerksted() {
    const {id} = useParams();
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const [verksted, setVerksted] = useState(null);

    //const {verksted, isLoading, isError} = useGetSingleVerksted(id);

    useEffect(() => {
        async function retrieveVerksted(){
            try {
                setIsLoading(true);
                setIsError(false);
                const response = await axiosAuthFetch(`${API_BASE_URL}/users/${id}?populate=*`);
                console.log(response);
                setVerksted(response);
            }catch(error) {
                console.error(error);
                setIsError(true);
            }finally {
                setIsLoading(false);
            }
        }

        retrieveVerksted();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    if(isLoading || !verksted) {
        return <Loader />
    }

    if(isError) {
        return <CustomAlert message="Oida, her har det skjedd noe galt! Vennligst prøv igjen!" />
    }

    return (
        <div>
            <VPadminVerkstedLayout verksted={verksted} />
        </div>
        
    )
}

export default VPspesVerksted;